module.exports = __webpack_public_path__ + "static/media/Margaret Ma.8f586ff9.png";